import type {
  ComposerDetailRaw,
  ComposerDetailUI,
  ComposerListRaw,
  ComposerRow,
} from "~/features/compoundRecordComposers/types";

function toComposerRow(raw: ComposerListRaw): ComposerRow {
  return {
    id: raw.id,
    key: raw.key,
    recordType: raw.recordType,
    updatedAt: raw.updatedAt,
  };
}

export function toComposerRowList(raws: readonly ComposerListRaw[]): ComposerRow[] {
  return raws.map(toComposerRow);
}

export function toComposerDetailUI(raw: ComposerDetailRaw): ComposerDetailUI {
  return {
    id: raw.id,
    key: raw.key,
    recordType: raw.recordType,
    properties: raw.properties as Record<string, unknown>,
    createdAt: raw.createdAt,
    updatedAt: raw.updatedAt,
  };
}
